











































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import { OfferForm } from '@/business/offers/models/offer-form'
import { Inject, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'
import { datePickerLabels } from '@/config/i18n/de'
import { OfferResponse } from '@/api/generated'
import { InputEvent } from '@/shared/models/input-event'

@Component({
  components: { UnifyFormInput, UnifyListItemContent, UnifyListItemLabel, UnifyListItem },
})
export default class OfferSettingsEvents extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly offer!: OfferResponse

  @Inject()
  public readonly form!: FormGroup<OfferForm>

  public readonly datePickerLabels = datePickerLabels

  public blurTime(event: InputEvent, date: any, control: any, index: number): void {
    let value = event.target?.value

    if (this.form.array('events').validations.$each[index][control]) {
      if (value && /\d{4}/.test(value)) {
        value = value.substring(0, 2) + ':' + value.substring(2, 4)
      } else if (/^\d{1,2}$/.test(value)) {
        value = value.padStart(2, '0') + ':00'
      }
    }

    date[control] = value as any
  }

  public isDirtyAndInvalid(index: number, controlName: any): boolean {
    const control: any = this.form.array('events').validations.$each[index][controlName]

    return control.$dirty && control.$invalid
  }

  public normalizeTime(event: InputEvent, date: any, control: any, index: number): void {
    let value = event.target?.value

    if (value && /\d{4}/.test(value)) {
      value = value.substring(0, 2) + ':' + value.substring(2, 4)
    }

    date[control] = value
    ;(this.form.array('events').validations.$each[index][control] as any).$touch()
  }

  public remove(index: number): void {
    this.form.array('events').value.splice(index, 1)
  }

  public validation(index: number) {
    return this.form.array('events').validations.$each[index]
  }
}
